import { useState } from "react";
import type { CreatePartnerInput, Partner } from "@lumora/bridge";
import { usePartnerVm } from "./platformViewModels.js";
import { ProvisionCard, useActionStatus } from "./ProvisionCard.js";

/** Admin: create a delivery partner (a tenant of kind "partner"). */
export function CreatePartnerForm({
  onCreated,
}: {
  onCreated: (p: Partner) => void;
}) {
  const [slug, setSlug] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const status = useActionStatus();
  const vm = usePartnerVm();

  return (
    <ProvisionCard
      title="Create partner"
      lead="A delivery partner (for example someone who builds and hosts sites for you) gets a platform page, a payment ledger, and can receive revenue splits."
      status={status}
    >
      <form
        className="site-signin"
        onSubmit={(e) => {
          e.preventDefault();
          status.start();
          const input: CreatePartnerInput = {
            slug: slug.trim(),
            name: name.trim(),
          };
          if (email.trim()) input.email = email.trim();
          void vm.createPartner(input).then(
            (p) => {
              status.ok(
                `Created partner ${p.name || input.name} (${p.slug || input.slug}).`,
              );
              setSlug("");
              setName("");
              setEmail("");
              onCreated(p);
            },
            (err: unknown) => status.fail(err, "Failed to create partner"),
          );
        }}
      >
        <label>
          Slug
          <input
            type="text"
            value={slug}
            onChange={(e) => setSlug(e.target.value)}
            pattern="[a-z0-9][a-z0-9-]*"
            placeholder="ali"
            required
          />
        </label>
        <label>
          Display name
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </label>
        <label>
          Email (optional)
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <button type="submit" className="ops-btn">
          Create partner
        </button>
      </form>
    </ProvisionCard>
  );
}
